"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingList = void 0;
require("./billing-list.less");
const React = require("react");
// import * as ReactTooltip from "react-tooltip";
// import * as moment from "moment";
const core_1 = require("@material-ui/core");
const mobx_1 = require("mobx");
const icons_1 = require("client/components/icons");
const select_1 = require("client/components/material/select");
const router_1 = require("client/components/router");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/billing/store");
const mobx_react_1 = require("mobx-react");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const styles = core_1.createStyles({
    root: {}
});
const decorate = core_1.withStyles(styles);
let BillingListUnstyled = class BillingListUnstyled extends router_1.TabRouter {
    constructor() {
        super(...arguments);
        this.siteId = 0;
        this.statement = 0;
        this.limitAll = 48; // // a year and a month // if we want data a one year to add  we need to one year data to add 26 B-042
        this.limitRecent = 8; // 3 months then we can use 6 B-042
        this.allStatementsBySite = [];
        this.recentStatementsBySite = [];
        this.iframeUrl = "";
        this.siteIds = [];
        this.userSites = [];
        this.userWithManySites = true;
        this.renderPharmacyHeader = () => (React.createElement("div", { className: "check__header" },
            React.createElement("div", { className: "edit-check-header" },
                React.createElement("div", { className: "eob-header-form__headline" },
                    React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "Select a Pharmacy")),
                React.createElement("div", { className: "row" },
                    React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "" })),
                React.createElement("br", null))));
        this.renderStatementHeader = () => (React.createElement("div", { className: "check__header" },
            React.createElement("div", { className: "edit-check-header" },
                React.createElement("div", { className: "eob-header-form__headline" },
                    React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "Select a Statement")),
                React.createElement("div", { className: "row" },
                    React.createElement(select_1.MaterialSelect, { options: this.availableStatementOptions, searchable: true, label: "Statement", onSelect: this.handleChangeStatement, value: String(this.statement) || "" })),
                React.createElement("br", null))));
        this.renderSelectedStatement = () => {
            var _a;
            return (React.createElement("div", { className: "check__header" },
                React.createElement("div", { className: "edit-check-header" },
                    React.createElement("div", { className: "eob-header-form__headline" },
                        React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "Selected Statement")),
                    React.createElement("br", null)),
                React.createElement("div", { className: "billing-list-overview__list-container" },
                    this.selectedStatement ? (React.createElement("li", { "data-tip": `${(_a = this.selectedStatement.description) !== null && _a !== void 0 ? _a : this.selectedStatement.fileOriginalName}`, onClick: () => {
                            this.iframeUrl = this.selectedStatement.filePath;
                            this.currentStatementViewing = this.selectedStatement;
                        }, className: "list" },
                        React.createElement("div", { className: "billing-list-overview__list-container__filename" },
                            React.createElement(icons_1.HistoryIcon, null),
                            React.createElement("a", { href: this.iframeUrl, target: "_blank", rel: "noreferrer noopener" }, this.selectedStatement.description ||
                                this.selectedStatement.fileOriginalName)))) : null,
                    React.createElement("br", null))));
        };
        this.renderRecentStatements = () => (React.createElement("div", { className: "check__header" },
            React.createElement("div", { className: "edit-check-header" },
                React.createElement("div", { className: "eob-header-form__headline" },
                    React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "Recent Statements")),
                React.createElement("br", null)),
            React.createElement("div", { className: "billing-list-overview__list-container" },
                this.renderRecentStatementRow(),
                store_1.billingStore.showLoader === false &&
                    this.recentStatementsBySite.length === 0 &&
                    this.renderNoRecentStatements())));
        this.renderNoRecentStatements = () => (React.createElement("div", { className: "check__header" },
            React.createElement("div", { className: "edit-check-header" },
                React.createElement("div", { className: "eob-header-form__headline" },
                    React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "There are no statements for the selected Pharmacy.")),
                React.createElement("br", null))));
        this.renderRecentStatementRow = () => {
            var _a;
            return ((_a = this.recentStatementsBySite) === null || _a === void 0 ? void 0 : _a.length) ? this.recentStatementsBySite.map((statement, index) => {
                var _a;
                return (React.createElement("li", { "data-tip": `${(_a = statement.description) !== null && _a !== void 0 ? _a : statement.fileOriginalName}`, onClick: () => {
                        this.iframeUrl = statement.filePath;
                        this.currentStatementViewing = statement;
                    }, key: index, className: "list" },
                    React.createElement("div", { className: "billing-list-overview__list-container__filename" },
                        React.createElement(icons_1.HistoryIcon, null),
                        React.createElement("a", { href: this.iframeUrl, target: "_blank", rel: "noreferrer noopener" }, statement.description || statement.fileOriginalName))));
            })
                : null;
        };
        // public handlePreviewClose = (): void => {
        //   this.iframeUrl = "";
        //   this.currentStatementViewing = null;
        // };
        this.handleChangeSite = async (id) => {
            this.siteId = Number(id);
            this.selectedStatement = null;
            this.allStatementsBySite = [];
            this.recentStatementsBySite = [];
            store_1.billingStore.showLoader = true;
            this.recentStatementsBySite = await store_1.billingStore.getStatementsById(this.siteId, this.limitRecent);
            this.allStatementsBySite = await store_1.billingStore.getStatementsById(this.siteId, this.limitAll);
        };
        this.handleChangeStatement = async (id) => {
            this.statement = Number(id);
            this.selectedStatement = null;
            store_1.billingStore.showLoader = true;
            this.selectedStatement = await store_1.billingStore.getSelectedStatement(this.siteId, this.statement);
        };
    }
    componentWillMount() {
        var _a, _b;
        if ((_a = store_3.usersStore.user.value) === null || _a === void 0 ? void 0 : _a.sites) {
            const siteIdsString = store_3.usersStore.user.value.sites.toString();
            this.siteIds = siteIdsString.split(",").map(Number);
        }
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            this.userWithManySites = true;
        }
        else {
            this.userWithManySites = ((_b = this.siteIds) === null || _b === void 0 ? void 0 : _b.length) > 1;
        }
    }
    async componentDidMount() {
        var _a;
        store_1.billingStore.showLoader = true;
        if (store_3.usersStore.user.value && store_3.usersStore.user.value.siteId) {
            this.siteId = store_3.usersStore.user.value.siteId;
            await this.handleChangeSite(String(this.siteId));
        }
        else {
            await store_2.sitesListStore.loadSitesNoRelation();
        }
        if ((_a = store_3.usersStore.user.value) === null || _a === void 0 ? void 0 : _a.sites) {
            this.userSites = await store_2.sitesListStore.loadSpecificSites(this.siteIds);
        }
        this.recentStatementsBySite = await store_1.billingStore.getStatementsById(this.siteId, this.limitRecent);
        this.allStatementsBySite = await store_1.billingStore.getStatementsById(this.siteId, this.limitAll);
    }
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    options.push({
                        id: i,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            if (this.userSites) {
                this.userSites.forEach((site, i) => {
                    options.push({
                        id: i,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
            else {
                const site = store_3.usersStore.user.value.site;
                const siteOption = {
                    id: site.id,
                    label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                    value: site.id.toString()
                };
                options.push(siteOption);
            }
        }
        return options;
    }
    get availableStatementOptions() {
        const options = [];
        this.allStatementsBySite.forEach((statement, i) => {
            options.push({
                id: i,
                label: statement.description || statement.fileOriginalName,
                value: statement.id.toString()
            });
        });
        return options;
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.userWithManySites ? this.renderPharmacyHeader() : null,
            React.createElement("br", null),
            this.renderStatementHeader(),
            React.createElement("br", null),
            store_1.billingStore.showLoader ? (React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "loader" })) : null,
            React.createElement("br", null),
            this.selectedStatement ? this.renderSelectedStatement() : null,
            this.renderRecentStatements(),
            React.createElement("br", null)));
    }
};
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "statement", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "limitAll", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "limitRecent", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "allStatementsBySite", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "recentStatementsBySite", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "currentStatementViewing", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "selectedStatement", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "siteIds", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "userSites", void 0);
__decorate([
    mobx_1.observable
], BillingListUnstyled.prototype, "userWithManySites", void 0);
__decorate([
    mobx_1.computed
], BillingListUnstyled.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], BillingListUnstyled.prototype, "availableStatementOptions", null);
BillingListUnstyled = __decorate([
    mobx_react_1.observer
], BillingListUnstyled);
exports.BillingList = decorate(BillingListUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/billing/modules/billing-list/billing-list.tsx
// module id = 3281
// module chunks = 0